import type { TFunction } from 'i18next';
import type { TAvantage } from '../../api/paiement/apporteurs';

// Libellé d'un avantage tarifaire, commun à l'espace de l'animateur et à
// l'administration.
export const libelleAvantage = (t: TFunction, a?: TAvantage): string => {
  if (!a || a.type === 'aucun') {
    return t('apporteur.avantage.aucun', 'Aucun avantage : les familles paient le tarif public');
  }
  if (a.type === 'pourcentage') {
    return t('apporteur.avantage.pourcentage', '{{valeur}} % de réduction sur chaque paiement', { valeur: a.valeur });
  }
  if (a.type === 'montant_fixe') {
    return t('apporteur.avantage.montant', '{{valeur}} {{devise}} de réduction par mois sur chaque paiement', {
      valeur: a.valeur, devise: a.devise,
    });
  }
  const prix = (a.prix ?? []).map((p) => `${p.prix} ${p.devise}`).join(' · ');
  return t('apporteur.avantage.prixFixe', 'Prix fixe par mois : {{prix}}', { prix });
};
